import { BOOKKEEPING_WAITLIST_STATES, type BookkeepingWaitlistState, type WaitlistEntryOut } from "./types";

function requireIntId(value: unknown, field: string): number {
  const n = typeof value === "number" ? value : Number(value);
  if (!Number.isInteger(n)) {
    throw new Error(`Invalid waitlist entry: ${field} must be an integer`);
  }
  return n;
}

function requireWaitlistState(value: unknown): BookkeepingWaitlistState {
  if (typeof value !== "string") {
    throw new Error("Invalid waitlist entry: state");
  }
  const state = BOOKKEEPING_WAITLIST_STATES.find((s) => s === value);
  if (!state) {
    throw new Error("Invalid waitlist entry: state");
  }
  return state;
}

type RawWaitlistEntry = {
  id?: unknown;
  companyId?: unknown;
  company_id?: unknown;
  state?: unknown;
  createdAt?: unknown;
  created_at?: unknown;
  updatedAt?: unknown;
  updated_at?: unknown;
};

/**
 * Ninja currently serialises `WaitlistEntryOut` with snake_case field names in JSON
 * (see `customerweb/tests/views/test_bookkeeping.py`). Normalise to the camelCase shape
 * the UI uses.
 */
export function parseWaitlistEntry(raw: unknown): WaitlistEntryOut {
  if (!raw || typeof raw !== "object") {
    throw new Error("Invalid waitlist entry payload");
  }
  const r = raw as RawWaitlistEntry;
  const companyId = r.companyId ?? r.company_id;
  const createdAt = r.createdAt ?? r.created_at;
  const updatedAt = r.updatedAt ?? r.updated_at;

  return {
    id: requireIntId(r.id, "id"),
    companyId: requireIntId(companyId, "companyId"),
    state: requireWaitlistState(r.state),
    createdAt: typeof createdAt === "string" ? createdAt : String(createdAt ?? ""),
    updatedAt: typeof updatedAt === "string" ? updatedAt : String(updatedAt ?? ""),
  };
}
